module.exports = __webpack_public_path__ + "img/circle-arrow.155e1c9a.svg";